import { triggerSnowplowClickEvent } from '@themuse/snowplow-js-client';
import { pagesToUse } from './snowPlowPages';

export const SnowplowClickTracker = ({
    component,
    componentTitleType = null,
    buttonText = null,
    buttonType = null,
    insertType = null,
    linkText = null,
    position = 'main',
    targetPageSection = null,
    searchId = null,
    isExternal = false,
    companyId = null,
    pageSection = null,
    pageTab = null,
    pageType = null,
    tileType = null,
    tileEntityId = null,
    tileEntityUuid = null,
    tileOrder = 1,
    tileLocation = null,
}) => {
    const userId = window.globalPageProps?.PAGE_PROPS?.session?.id;
    const index = window.dataLayer.findIndex((obj) => 'sp_page_section' in obj);
    const pageData = {
        sp_page_is_external: isExternal,
        sp_page_section: pageSection,
        sp_page_tab: pageTab,
        sp_page_type: pageType,
        sp_page_sponsor_id: companyId ? String(companyId) : null,
        sp_user_id: userId,
        sp_user_logged_in: !!userId,
    };
    if (index >= 0) {
        window.dataLayer[index] = pageData;
    } else {
        window.dataLayer.push(pageData);
    }

    const clickEventProps = {
        sp_click_component: component,
        sp_click_component_tile_type: tileType,
        sp_click_button_text: buttonText,
        sp_click_button_type: buttonType,
        sp_click_insert_type: insertType,
        sp_click_link_text: linkText,
        sp_click_position: position,
        sp_click_target_page_section: targetPageSection,
        sp_click_search_id: searchId,
        sp_user_id: userId,
        sp_user_logged_in: !!userId,
        sp_tile_type: tileType,
        sp_tile_entity_id: tileEntityId,
        sp_tile_entity_uuid: tileEntityUuid,
        sp_tile_order: tileOrder,
        sp_tile_location: tileLocation,
        sp_tile_company_id: companyId ? String(companyId) : null,
    };

    triggerSnowplowClickEvent(clickEventProps);
};

export const convertMetricToSnowPlowClickTracker = (snowPlow) => {
    const page = window.location.pathname;
    // if the page is not in the pages to use return null
    if (!pagesToUse.includes(page)) return null;
    SnowplowClickTracker({
        ...snowPlow,
    });
};
